import { cloneDeep } from 'lodash';
const SET_PRODUCTS = 'SET_PRODUCTS';

const initialState = [];

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_PRODUCTS:
			return action.payload;
		default:
			return state;
	}
}

export function setProducts( products=[] ){
	return{
		type: SET_PRODUCTS,
		payload: products
	}
}



// WEBPACK FOOTER //
// ./src/modules/products.js